import React from 'react';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { ClassroomLicenseUsage } from 'types/schema-generated-types';
import ProductIconList from 'components/@common/ProductIconList';

export interface ClassroomCardContentFragmentProps {
  educator?: string;
  coeducators?: string;
  organizationName?: string;
  studentCount: number;
  licenseUsage?: ClassroomLicenseUsage[] | null;
}

const ClassroomCardContentFragment: React.FC<ClassroomCardContentFragmentProps> = ({
  educator,
  coeducators,
  licenseUsage,
  organizationName,
  studentCount
}) => {
  const { t } = useTranslation('ClassroomsTileViewContainer');

  return (
    <>
      <Typography variant="body1">
        {t('Educator')}: {educator}
      </Typography>
      <Typography variant="body1">
        {t('Co-Educators')}: {coeducators}
      </Typography>
      <Typography variant="body1">
        {t('Organization')}: {organizationName}
      </Typography>
      <Typography variant="body1">
        {t('No. of Students')}: {studentCount}
      </Typography>
      <ProductIconList
        licenseUsage={licenseUsage}
        title={t('Products')}
        emptyMessage={t('No assigned products')}
      />
    </>
  );
};

export default ClassroomCardContentFragment;
